var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron-img",style:({'background-image': 'url(' + require('@/assets/img/fullwidth/jumbotron-pattern.png' ) + ')'})},[_c('div',{staticClass:"jumbotron-text"},[_vm._v("\n    "+_vm._s(this.title)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efa83fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jumbotron/Jumbotron.vue
// module id = null
// module chunks = 